export default __webpack_public_path__ + "assets/images/logo-backgroundb9e23702941198ae986a9c994bc73224.png";